import { useEffect, useState } from 'react';

import { isMac } from '@/utils/capabilities';

import type { DevicePermissionStatus } from '@electron/shared/permission.types';

interface EventKitState {
  calendarGranted: boolean;
  remindersGranted: boolean;
  calendarStatus: DevicePermissionStatus | null;
  remindersStatus: DevicePermissionStatus | null;
}

const DEFAULT_STATE: EventKitState = {
  calendarGranted: false,
  remindersGranted: false,
  calendarStatus: null,
  remindersStatus: null,
};

/**
 * Thin hook that reads EventKit permission state from the main process.
 * All lifecycle logic (coordinator start/stop, polling, feature flags)
 * lives in EventKitManager on the Electron side.
 */
export function useEventKitState(): EventKitState {
  const [state, setState] = useState<EventKitState>(DEFAULT_STATE);

  useEffect(() => {
    if (!isMac()) {
      return;
    }

    window.mainProcessApi.getEventKitState().then(setState);
    const cleanup = window.mainProcessApi.onEventKitStateChanged(setState);
    return cleanup;
  }, []);

  return state;
}
